import Seo from '../components/Seo';

const sections = [
  {
    title: 'Use of DropBridge',
    body: 'DropBridge is intended to help Shopify merchants create, edit, price, and publish product listing drafts from merchant-selected supplier details, and to keep the prices and stock of products the merchant chooses in step with the supplier through Auto Sync. Users are responsible for reviewing all product information before publishing.',
  },
  {
    title: 'Authorized use',
    body: 'You may only use DropBridge with product information you are authorized to use. You are responsible for respecting supplier terms, marketplace rules, intellectual property rights, and Shopify policies.',
  },
  {
    title: 'Merchant responsibilities',
    body: 'You are responsible for supplier relationships, product compliance, pricing decisions, store content, and fulfillment obligations.',
  },
  {
    title: 'Subscriptions',
    body: 'DropBridge is offered on a Free plan and three paid plans. The Free plan costs nothing and includes up to 10 product imports in total, Auto Sync for up to 10 products at a time, 10 "Improve with AI" title and description rewrites, and 10 image background removals; the imports, rewrites and background removals are a one-time allowance and do not renew. Importing a product by link on the Free plan requires connecting your AliExpress account. The paid plans all include unlimited product imports, Auto Sync for supplier price and stock updates, the AI tools and priority support, and differ in their limits: Pro is $18.90 per month or $189.99 per year and synchronizes up to 100 products, with 75 rewrites and 75 background removals per day; Business is $49.90 per month or $479.90 per year for up to 500 products, with 300 rewrites and 300 background removals per day; Scale is $129.90 per month or $1,249.90 per year for up to 2,000 products, with 750 rewrites and 750 background removals per day, and includes onboarding. On every plan, rewrites and background removals are counted separately, and changing the background colour of an image that has already been processed does not count against either allowance. Pro includes a 3-day free trial; Business and Scale do not include a trial. Paid AI allowances reset daily at 00:00 UTC and unused actions do not carry over. Subscriptions are billed through Shopify and can be cancelled at any time from your Shopify admin. Plan limits and billing terms may be updated in accordance with applicable platform requirements.',
  },
  {
    title: 'Service availability',
    body: 'We aim to provide a reliable service, but availability may vary due to maintenance, third-party services such as AliExpress and Shopify, platform changes, or events outside our control.',
  },
  {
    title: 'Contact',
    body: 'For terms questions, contact support@dropbridgeapp.com.',
  },
];

export default function TermsOfService() {
  return (
    <>
      <Seo
        title="Terms of Service"
        description="Terms of service for merchants using DropBridge to create, edit, and publish Shopify product drafts from supplier information."
        path="/terms-of-service"
      />
      <section className="pb-24 pt-32">
        <div className="container-page max-w-4xl">
          <p className="eyebrow">Legal</p>
          <h1 className="mt-4 text-4xl font-bold tracking-tight text-slate-950 dark:text-white sm:text-5xl">
            Terms of Service
          </h1>
          <p className="mt-5 text-slate-600 dark:text-slate-300">Last updated: October 3, 2026</p>
          <div className="mt-10 grid gap-5">
            {sections.map((section) => (
              <article key={section.title} className="surface rounded-2xl p-6">
                <h2 className="text-xl font-semibold text-slate-950 dark:text-white">
                  {section.title}
                </h2>
                <p className="mt-3 leading-7 text-slate-600 dark:text-slate-300">{section.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
